export default __webpack_public_path__ + "static/media/safety-boots-icon.2f41ba95.svg";